// @flow
import React from 'react';
import classNames from 'classnames';
import Skeleton from 'react-loading-skeleton';
import {Link} from 'react-router-dom';
import api from 'utils/API';
import {withStyles} from '@material-ui/core/styles';
import styles from './PostActions.styles.js';
import Icon from 'app/components/Icon';
import {getVote, setVote, removeVote} from 'utils/Helper';

type Props = {
  value: any
};

type State = {
  value: any
};

class PostActions extends React.Component<Props, State> {
  unmounted = false;
  
  constructor(props) {
    super(props);

    const initData = props.initData || {};

    this.state = {
      likes: initData.likes || 0,
      comments: initData.comments || false,
    };
  }

  send = (postId, action) => {
    const vote = getVote('post', postId);
    // user voted before
    if (vote) {
      return;
    }

    // Update vote locally before send to server to prevent duplicate send by user
    const value = action === 'like' ? 1 : -1;
    setVote('post', postId, value);
    this.setState({
      [`${action}s`]: Number(this.state[`${action}s`]) + 1
    });
    //

    const url = `/posts/${action}`;
    const data = {
      id: postId,
      type: 'post'
    };
    api.post(url, data)
    .then(response => {
      // const data = response.data;
    })
    .then(response => {})
    .catch(error => {
      if (this.unmounted) {
        return;
      }
      removeVote('post', postId, value);
      this.setState({
        [`${action}s`]: Number(this.state[`${action}s`]) - 1
      });
    });
  }

  sendHandle = (postId, action) => () => this.send(postId, action);

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.initData !== this.props.initData) {
      const initData = this.props.initData;
      this.setState({...initData});
    }
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  render() {
    const {classes, initData} = this.props;
    const likeSelected = getVote('post', initData.postId) === 1;

    if (!this.state.likes) {
      return <Skeleton width={125} height={20} />
    }

    return (
      <div>
        {(this.state.comments && this.state.comments !== false) &&
          <Link
            className={classNames(classes.item, classes.comment)}
            to={`/${initData.url}?goto=comments`}
          >
            {this.state.comments}
            <Icon className={classes.itemIcon} name="chat_bubble" />
          </Link>
        }
        
        <span
          className={classNames(classes.item, classes.like, {selected: likeSelected})}
          onClick={this.sendHandle(initData.postId, 'like')}
        >
          {this.state.likes}
          <Icon className={classes.itemIcon} name="thumb_up" />
        </span>
        
      </
      div>
    );
  }
}

const Component = withStyles(styles)(PostActions);
export {Component as PostActions};
export default Component;